import React from "react";
import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  Link,
  useTheme,
  useMediaQuery,
  Typography
} from "@material-ui/core";

import { SMGBacking as SMGBackingIcon, Facebook, LinkedIn, Instagram } from "../Icons";
import LinkEcco, { WrappedLinkRouter } from "../Link";

import { useStyles } from "../../hooks";
import styles from "./styles";
import { PUBLICURL, WEBPAGE, STATICPAGES } from "../../main_config";

const Footer = () => {
  const classes = useStyles(styles);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));
  let assets = STATICPAGES;
  assets = assets.replace("staticpages", "");
  return (
    <Box component="footer" className={classes.root}>
      {!matches &&
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: "center",
            marginBottom: "25px",
            marginTop: "-20px"
          }}
          className={classes.redesMobile}
        >
          <Grid xs={3} className={classes.textMobile}>¡Seguinos!</Grid>
          <Grid xs={6} /* className={classes.crossIcon} */ >
            <LinkEcco
              external={true}
              url="https://www.facebook.com/eccoemergencias"
              href="https://www.facebook.com/eccoemergencias"
              target="_blank"
              style={{ cursor: 'pointer', color: "#fff" }}
            >
              <Facebook style={{ marginRight: 20 }} />
            </LinkEcco>
            <LinkEcco
              external={true}
              url="https://www.instagram.com/eccoemergencias"
              href="https://www.instagram.com/eccoemergencias"
              target="_blank"
              style={{ cursor: 'pointer', color: "#fff" }}
            >
              <Instagram style={{ marginRight: 20 }} />
            </LinkEcco>
            <LinkEcco
              external={true}
              url="https://www.linkedin.com/company/eccoemergencias"
              href="https://www.linkedin.com/company/eccoemergencias"
              target="_blank"
              style={{ cursor: 'pointer', color: "#fff" }}
            >
              <LinkedIn />
            </LinkEcco>
          </Grid>
          </Grid>
        }
      <Grid
        container
        spacing={0}
        justifyContent="space-between"
      >
        <Grid item xs={12} sm={12} md={12}>
          <Grid container spacing={0} >
            <Grid item xs={6} sm={3} className={classes.info} style={matches ? { marginRight: -40 } : { marginRight: 0 }}>
              <List dense disablePadding>
                <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                  <ListItemText
                    disableTypography
                    classes={{ dense: classes.textDense }}
                  >
                    <Box component="span" className={classes.text}>
                      Superintendencia de Servicios de Salud
                    </Box>
                  </ListItemText>
                </ListItem>
                <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                  <ListItemText
                    disableTypography
                    classes={{ dense: classes.textDense }}
                  >
                    <Box component="span" className={classes.text}>
                      Organo Control 0800-222-SALUD (72583)
                    </Box>
                  </ListItemText>
                </ListItem>
                <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                  <ListItemText
                    disableTypography
                    classes={{ dense: classes.textDense }}
                  >
                    <Link
                      href="http://www.sssalud.gob.ar"
                      target="_blank"
                      className={classes.text}
                      underline="none"
                      color="inherit"
                    >
                      www.sssalud.gob.ar
                    </Link>
                    <Box component="span" className={classes.text}>
                      {" | RNEMP Nº 1347"}
                    </Box>
                  </ListItemText>
                </ListItem>
              </List>
            </Grid>


            {!matches ? (
              <Grid item xs={6} sm={7} md={6}>
                <Grid container spacing={0} className={classes.wrappedlogoSmg} style={{ marginTop: -20, marginBottom: 20 }}>

                  <Grid item xs={12}>
                    <List dense disablePadding>
                      <ListItem disableGutters classes={{ dense: classes.itemDense  }}>
                        <ListItemText
                          disableTypography
                          classes={{ dense: classes.textDenseMobile }}
                        >
                          <Link
                            href={`${WEBPAGE}/st/linea-denuncias`}
                            className={classes.textLink}
                            underline="none"
                            color="inherit"
                          >
                            Línea de denuncias
                          </Link>
                        </ListItemText>
                      </ListItem>
                      <ListItem disableGutters classes={{ dense: classes.itemDense  }}>
                        <ListItemText
                          disableTypography
                          classes={{ dense: classes.textDenseMobile }}
                        >
                          <Link
                            href={`${WEBPAGE}/st/solicitud-baja`}
                            className={classes.textLink}
                            underline="none"
                            color="inherit"
                          >
                            Solicitá la baja
                          </Link>
                        </ListItemText>
                      </ListItem>
                      <ListItem disableGutters classes={{ dense: classes.itemDense  }}>
                        <ListItemText
                          disableTypography
                          classes={{ dense: classes.textDenseMobile }}
                        >
                          <Link
                            href={`${WEBPAGE}/st/solicitud-arrepentimiento`}
                            className={classes.textLink}
                            underline="none"
                            color="inherit"
                          >
                            Solicitá el arrepentimiento
                          </Link>
                        </ListItemText>
                      </ListItem>
                      <ListItem disableGutters classes={{ dense: classes.itemDense  }}>
                        <ListItemText
                          disableTypography
                          classes={{ dense: classes.textDenseMobile }}
                        >
                          <Link
                            href={`${assets}assets/pdf/Contrato_de_Adhesión_Ley_N_24240_de_Defensa_del_Consumidor.pdf`}
                            target="_blank"
                            className={classes.textLink}
                            underline="none"
                            color="inherit"
                          >
                            Contrato de Adhesión
                          </Link>
                        </ListItemText>
                      </ListItem>
                      <ListItem disableGutters classes={{ dense: classes.itemDense  }}>
                        <ListItemText
                          disableTypography
                          classes={{ dense: classes.textDenseMobile }}
                        >
                          <Link
                            href={`${assets}assets/pdf/y385etjo.pdf`}
                            target="_blank"
                            className={classes.textLink}
                            underline="none"
                            color="inherit"
                          >
                            Código de Gobierno Corporativo
                          </Link>
                        </ListItemText>
                      </ListItem>
                      <ListItem disableGutters classes={{ dense: classes.itemDense  }}>
                        <ListItemText
                          disableTypography
                          classes={{ dense: classes.textDenseMobile }}
                        >
                          <Link
                            href={`${assets}assets/pdf/ut3424om.pdf`}
                            target="_blank"
                            className={classes.textLink}
                            underline="none"
                            color="inherit"
                          >
                            Código de Ética
                          </Link>
                        </ListItemText>
                      </ListItem>
                    </List>
                  </Grid>
                </Grid>
              </Grid>
              ) : ( 
                <Grid item xs={5} sm={6} md={7} style={{ marginRight: -80 }}>
                  <Grid container spacing={0} className={classes.wrappedlogoSmg} style={{marginTop:'-20px'}} >

                    <Grid item xs={6} sm={3} className={classes.borderLeft} style={{ display: "block" }}>
                      <SMGBackingIcon className={classes.smgImage} />
                    </Grid>

                    <Grid item xs={5} sm={4} >
                      <List dense>
                        <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                          <ListItemText
                            disableTypography
                            classes={{ dense: classes.LinkDense2 }}
                          >
                            <Link
                              href={`${WEBPAGE}/st/linea-denuncias`}
                              className={classes.text}
                              underline="none"
                              color="inherit"
                            >
                              Línea de denuncias
                            </Link>
                          </ListItemText>
                        </ListItem>
                        <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                          <ListItemText
                            disableTypography
                            classes={{ dense: classes.LinkDense2 }}
                          >
                            <Link
                              href={`${WEBPAGE}/st/solicitud-baja`}
                              className={classes.text}
                              underline="none"
                              color="inherit"
                            >
                              Solicitá la baja
                            </Link>
                          </ListItemText>
                        </ListItem>
                        <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                          <ListItemText
                            disableTypography
                            classes={{ dense: classes.LinkDense2 }}
                          >
                            <Link
                              href={`${WEBPAGE}/st/solicitud-arrepentimiento`}
                              className={classes.text}
                              underline="none"
                              color="inherit"
                            >
                              Solicitá el arrepentimiento
                            </Link>
                          </ListItemText>
                        </ListItem>
                        <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                          <ListItemText
                            disableTypography
                            classes={{ dense: classes.LinkDense2 }}
                          >
                            <Link
                              href={`${assets}assets/pdf/Contrato_de_Adhesión_Ley_N_24240_de_Defensa_del_Consumidor.pdf`}
                              target="_blank"
                              className={classes.text}
                              underline="none"
                              color="inherit"
                            >
                              Contrato de Adhesión
                            </Link>
                          </ListItemText>
                        </ListItem>
                        <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                          <ListItemText
                            disableTypography
                            classes={{ dense: classes.LinkDense2 }}
                          >
                            <Link
                              href={`${assets}assets/pdf/y385etjo.pdf`}
                              target="_blank"
                              className={classes.text}
                              underline="none"
                              color="inherit"
                            >
                              Código de Gobierno Corporativo
                            </Link>
                          </ListItemText>
                        </ListItem>
                        <ListItem disableGutters classes={{ dense: classes.itemDense }}>
                          <ListItemText
                            disableTypography
                            classes={{ dense: classes.LinkDense2 }}
                          >
                            <Link
                              href={`${assets}assets/pdf/ut3424om.pdf`}
                              target="_blank"
                              className={classes.text}
                              underline="none"
                              color="inherit"
                            >
                              Código de Ética
                            </Link>
                          </ListItemText>
                        </ListItem>
                      </List>
                    </Grid>

                    <Grid item xs={2} sm={2} className={classes.borderRight} style={{marginTop:'10px'}}>
                      <Box className={classes.crossIcon}  >
                        <Typography className={classes.textRedes} style={{ marginBottom: 4, marginLeft: 4 }}>
                          ¡Seguinos!
                        </Typography>
                        <LinkEcco
                          external={true}
                          url="https://www.facebook.com/eccoemergencias"
                          href="https://www.facebook.com/eccoemergencias"
                          target="_blank"
                          style={{ cursor: 'pointer', color: "#fff" }}
                        >
                          <Facebook style={{ marginRight: 5 }} />
                        </LinkEcco>
                        <LinkEcco
                          external={true}
                          url="https://www.instagram.com/eccoemergencias"
                          href="https://www.instagram.com/eccoemergencias"
                          target="_blank"
                          style={{ cursor: 'pointer', color: "#fff" }}
                        >
                          <Instagram style={{ marginRight: 5 }} />
                        </LinkEcco>
                        <LinkEcco
                          external={true}
                          url="https://www.linkedin.com/company/eccoemergencias"
                          href="https://www.linkedin.com/company/eccoemergencias"
                          target="_blank"
                          style={{ cursor: 'pointer', color: "#fff" }}
                        >
                          <LinkedIn />
                        </LinkEcco>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
            )}   

            { !matches ? (
              <Grid container>
              <Grid item xs={6} style={{marginTop:'-20px'}}>
              <Box className={classes.wrappedLogoLegal}>
                <img
                  src={`${PUBLICURL}/assets/images/legal-group/logo_verisign.png`}
                  alt="Verisign"
                  //className={classes.logoSmg}
                />
                <img
                  src={`${PUBLICURL}/assets/images/legal-group/logo_ministerio_justicia.png`}
                  alt="Ministerio de Justicia"
                  //className={classes.logoSmg}
                />
              </Box>
            </Grid>
              <Grid item xs={6} style={{marginTop:'-10px'}}>
                <Box>
                  <SMGBackingIcon className={classes.smgImageMobile} /> 
                </Box>
              </Grid></Grid> ) : (
              <Grid item xs="auto" md={2} style={{width:'125%'}}>
                <Box className={classes.wrappedLogoLegal} >
                  <img
                    src={`${PUBLICURL}/assets/images/legal-group/logo_verisign.png`}
                    alt="Verisign"
                    //className={classes.logoSmg}
                  />
                  <img
                    src={`${PUBLICURL}/assets/images/legal-group/logo_ministerio_justicia.png`}
                    alt="Ministerio de Justicia"
                    //className={classes.logoSmg}
                  />
                </Box>
              </Grid>)}          
          </Grid>
        </Grid>

      </Grid>
    </Box>
  );
};

export default Footer;
